import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { WEB_SERVICE_MIMS, applications } from "../../../../config/constants";
// Components
import {
  AppsDiv,
  TitleTextDiv,
  DataDiv,
  InputPositioner,
  InputDataDiv,
  Label,
  AppImg,
  InputCheckboxDiv,
  InputCheckbox,
  VerifyCheckboxImg,
} from "./styles";
import Axios from "../../../../config/axios";
// Assets
import RGSClinic from "../../../../assets/icons/ico_clinic_gray.svg";
import RGSWear from "../../../../assets/icons/ico_wear_gray.svg";
import RGSIcu from "../../../../assets/icons/ico_icu_gray.svg";
import RGSPlus from "../../../../assets/icons/ico_plus_gray.svg";
import CheckTrue from "../../../../assets/icons/ico_checkbox_true.svg";
import CheckFalse from "../../../../assets/icons/ico_checkbox_false.svg";

const Apps = ({ appsArray }) => {
  const [clinic, setClinic] = useState(false);
  const [wear, setWear] = useState(false);
  const [icu, setIcu] = useState(false);
  const [plus, setPlus] = useState(false);
  const [hospitalSoftwares, setHospitalSoftwares] = useState([]);
  const hospitalId = useSelector(({ clinician }) => clinician.data.HOSPITAL_ID);
  const [t] = useTranslation("global");

  useEffect(() => {
    if (hospitalId) {
      Axios("get", `${WEB_SERVICE_MIMS}/hospitals/software/${hospitalId}`)
        .then(({ data }) => {
          setHospitalSoftwares(
            data.filter(
              (application) => application.SOFTWARE_ID !== applications.home.id && application.SOFTWARE_ID !== applications.web.id
            )
          );
        })
        .catch((error) => {
          console.log("Endpoint to get hospital softwares: ", error);
        });
    }
  }, [hospitalId]);

  const handleSetSoftware = (software, setSoftware, idSoftware) => {
    if (!software) {
      setSoftware(true);
      appsArray.push(idSoftware);
    } else {
      setSoftware(false);
      const index = appsArray.indexOf(idSoftware);
      appsArray.splice(index, 1);
    }
  };

  return (
    <AppsDiv>
      <TitleTextDiv>
        <p>{t("rgsPrescriptions_rgsApplicationsTitle")}</p>
      </TitleTextDiv>
      <DataDiv justifyContent={hospitalSoftwares.length > 1}>
        {/* Show RGS Clinic */}
        {hospitalSoftwares.filter((software) => software.SOFTWARE_ID === applications.clinic.id).length > 0 && (
          <InputPositioner>
            <InputDataDiv>
              <Label htmlFor="rgsclinic">RGS Clinic</Label>
              <AppImg src={RGSClinic} alt="rgs-clinic" />
              <InputCheckboxDiv>
                <InputCheckbox
                  type="checkbox"
                  id="rgsclinic"
                  value={clinic}
                  onClick={() => handleSetSoftware(clinic, setClinic, applications.clinic.id)}
                />
                {clinic ? <VerifyCheckboxImg src={CheckTrue} alt="check-true" /> : <VerifyCheckboxImg src={CheckFalse} alt="check-false" />}
              </InputCheckboxDiv>
            </InputDataDiv>
          </InputPositioner>
        )}
        {/* Show RGS Wear */}
        {hospitalSoftwares.filter((software) => software.SOFTWARE_ID === applications.wear.id).length > 0 && (
          <InputPositioner>
            <InputDataDiv>
              <Label htmlFor="rgswear">RGS Wear</Label>
              <AppImg src={RGSWear} alt="rgs-wear" />
              <InputCheckboxDiv>
                <InputCheckbox
                  type="checkbox"
                  id="rgswear"
                  value={wear}
                  onClick={() => handleSetSoftware(wear, setWear, applications.wear.id)}
                />
                {wear ? <VerifyCheckboxImg src={CheckTrue} alt="check-true" /> : <VerifyCheckboxImg src={CheckFalse} alt="check-false" />}
              </InputCheckboxDiv>
            </InputDataDiv>
          </InputPositioner>
        )}
        {/* Show RGS ICU */}
        {hospitalSoftwares.filter((software) => software.SOFTWARE_ID === applications.icu.id).length > 0 && (
          <InputPositioner>
            <InputDataDiv>
              <Label htmlFor="rgsicu">RGS ICU</Label>
              <AppImg src={RGSIcu} alt="rgs-icu" />
              <InputCheckboxDiv>
                <InputCheckbox
                  type="checkbox"
                  id="rgsicu"
                  value={icu}
                  onClick={() => handleSetSoftware(icu, setIcu, applications.icu.id)}
                />
                {icu ? <VerifyCheckboxImg src={CheckTrue} alt="check-true" /> : <VerifyCheckboxImg src={CheckFalse} alt="check-false" />}
              </InputCheckboxDiv>
            </InputDataDiv>
          </InputPositioner>
        )}
        {/* Show RGS Plus */}
        {hospitalSoftwares.filter((software) => software.SOFTWARE_ID === applications.plus.id).length > 0 && (
          <InputPositioner>
            <InputDataDiv>
              <Label htmlFor="rgsplus">{t("applications_plus")}</Label>
              <AppImg src={RGSPlus} alt="rgs-plus" />
              <InputCheckboxDiv>
                <InputCheckbox
                  type="checkbox"
                  id="rgsplus"
                  value={plus}
                  onClick={() => handleSetSoftware(plus, setPlus, applications.plus.id)}
                />
                {plus ? <VerifyCheckboxImg src={CheckTrue} alt="check-true" /> : <VerifyCheckboxImg src={CheckFalse} alt="check-false" />}
              </InputCheckboxDiv>
            </InputDataDiv>
          </InputPositioner>
        )}
      </DataDiv>
    </AppsDiv>
  );
};

export default Apps;
